/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delete_DeletingInputs */

const he_account_delete_deleting = /** @type {(inputs: Account_Delete_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוחק...`)
};

const en_account_delete_deleting = /** @type {(inputs: Account_Delete_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Account_Delete_DeletingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delete_deleting = /** @type {((inputs?: Account_Delete_DeletingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delete_DeletingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delete_deleting(inputs)
	return en_account_delete_deleting(inputs)
});